import { gql } from '@apollo/client';
export const companyIdQuery = gql `
  query DownloadDocumentCompanyIdFromCache {
    account @client {
      companyId
    }
  }
`;
